import { render } from "./AlphaGoat01S3.vue?vue&type=template&id=4c7bb522"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__